import Feature from "src/js/stores/user/Feature";
import {
  ComparablesLayerSummaryType,
  ComparablesLayerType,
  HometrackLayerSummaryTypeRental,
  HometrackLayerSummaryTypeSale,
  LocalMarketValueSummaryLayerType,
} from "../layer_types/ComparablesLayerType";
import { Layer, LayerGroup } from "../types";

export const COMPARABLES_LAYER: Layer = {
  id: "COMPARABLES",
  layerType: ComparablesLayerType,
  title: "Comparables",
  requiredFeatureAccess: [Feature.pricepaidLayer],
  toggleable: true,
  group: LayerGroup.GENERAL,
  icon: "lt-layer-comparables",
  description: "Calculate sale prices and market rents",
  zoomConfig: {
    minVisualisationZoom: 13,
  },
};

export const COMPARABLES_LAYER_US: Layer = {
  ...COMPARABLES_LAYER,
  description: "Sale price and market values",
  hideByDefault: true,
};

export const COMPARABLES_LAYER_SUMMARY_UK: Layer = {
  id: "COMPARABLES_SUMMARY",
  layerType: ComparablesLayerSummaryType,
  title: "Latest transaction",
  requiredFeatureAccess: [Feature.insightsSummary, Feature.pricepaidLayer],
  toggleable: true,
  description: "The latest transaction in the selected area",
  hideByDefault: true,
};

export const LOCAL_MARKET_VALUE_LAYER_SUMMARY_UK: Layer = {
  id: "LOCAL_MARKET_VALUE_SUMMARY",
  layerType: LocalMarketValueSummaryLayerType,
  title: "Local market value",
  requiredFeatureAccess: [Feature.insightsSummary, Feature.comparablesCalculator], // Feature tied to comparable calculator
  toggleable: true,
  description: "The latest transaction in the selected area",
  hideByDefault: true,
};

export const COMPARABLES_LAYER_SUMMARY_US: Layer = {
  id: "COMPARABLES_SUMMARY",
  layerType: ComparablesLayerSummaryType,
  title: "Latest transaction",
  requiredFeatureAccess: [Feature.insightsSummary],
  toggleable: true,
  description: "The latest transaction in the selected area",
  hideByDefault: true,
};

export const HOMETRACK_LAYER_SUMMARY_SALE: Layer = {
  id: "HOMETRACK_SUMMARY_SALE",
  layerType: HometrackLayerSummaryTypeSale,
  title: "Hometrack local values",
  requiredFeatureAccess: [Feature.insightsSummary, Feature.zooplaFullAccess],
  toggleable: true,
  description: "A summary of hometrack sales data in the selected area",
  hideByDefault: true,
};

export const HOMETRACK_LAYER_SUMMARY_RENTAL: Layer = {
  id: "HOMETRACK_SUMMARY_RENTAL",
  layerType: HometrackLayerSummaryTypeRental,
  title: "Hometrack local rents",
  requiredFeatureAccess: [Feature.insightsSummary, Feature.zooplaFullAccess],
  toggleable: true,
  description: "A summary of hometrack rental data in the selected area",
  hideByDefault: true,
};
